/*
API to key/value store

- insert( key, value )
- search( key )
- delete( key )
- clear()
- keys
*/

import { store as theStore } from '../store/store';
import { keyValueStoreActions as valueActions } from '../store/keyValueStore';

const keyValueStore = {}

keyValueStore.insert = function(key, value) {
  theStore.dispatch( valueActions.store({
    key: key,
    value: value
  }));    
}

keyValueStore.search = function(key) {
  return theStore.getState().keyValueStore.values[key];
}

keyValueStore.delete = function(key) {
  theStore.dispatch( valueActions.remove({ key: key }) );
}

keyValueStore.clear = function() {
  theStore.dispatch( valueActions.clear() );
}

keyValueStore.keys = function keys() {
  return Object.keys(theStore.getState().keyValueStore.values);
}

keyValueStore.exists = function(key) {
  return key in keys();
};


export default keyValueStore;

/*
import { store } from "../App/store";
import { slice as counterSlice } from "../features/counterSlice";

export function getCount(): number {
  const state = store.getState();
  return state.counter.value;
}

export function incrementCount() {
  store.dispatch(counterSlice.actions.increment());
}
*/